module.exports = __webpack_public_path__ + "static/media/snacks_image1.46436ead.jpg";